import { Helper } from "../../helpers/Helper";

/**
 * Modal Class
 */
export class Modal {

	/**
	 * Constructor
	 *
	 * @param {string} containerEl
	 * @return {void}
	 */
	constructor( containerEl ) {

		this.allBlocks = document.querySelectorAll( containerEl );
		if ( !this.allBlocks || this.allBlocks.length === 0 ) {

			return false;

		}

		this.init();

	}

	/**
	 * openModal
	 *
	 * @param {node} modal
	 * @param {node} overlay
	 * @return {void}
	 */
	openModal ( modal, overlay ) {

		this.moveOutOverlay( modal, overlay )
		modal.classList.remove( "hidden" );
		overlay.classList.remove( "hidden" );

	};

	/**
	 * closeModal
	 *
	 * @param {node} modal
	 * @param {node} overlay
	 * @param {node} block
	 *
	 * @return {void}
	 */
	closeModal( modal, overlay, block ) {

		modal.classList.add( "hidden" );
		overlay.classList.add( "hidden" );
		this.moveOverlayToBegin( modal, overlay, block );

	};

	/**
	 * Move out Overlay from the default wrapper
	 * @param {node} modal
	 * @param {node} overlay
	 * @return {void}
	 */
	moveOutOverlay( modal, overlay ) {

		document.body.appendChild( overlay );
		document.body.appendChild( modal );

	}

	/**
	 * Move Overlay to the default wrapper
	 * @param {node} modal
	 * @param {node} overlay
	 * @param {node} block
	 * @return {void}
	 */
	moveOverlayToBegin(  modal, overlay, block ) {

		block.appendChild( overlay );
		block.appendChild( modal );

	}

	/**
	 * Init
	 *
	 * @return {void}
	 */
	init() {

		if ( this.allBlocks.length > 0 ) {

			this.allBlocks.forEach( ( block ) => {

				if ( block.classList.contains( "has-modal" ) ) {

					const modal = block.querySelector( ".modal" );
					const overlay = block.querySelector( ".overlay" );
					const btnCloseModal = block.querySelector( ".close-modal" );

					/**
					 * clickedHandler
					 */
					const clickedHandler = (  ) => {

						this.openModal( modal, overlay )

					}

					btnCloseModal.addEventListener( "click", () => {

						this.closeModal( modal, overlay, block )

					} );

					if( Helper.hasClass( block, "show-modal" ) ){

						block.addEventListener( "click", clickedHandler );

					}

					overlay.addEventListener( "click", () => {

						this.closeModal( modal, overlay )

					} );

					document.addEventListener( "keydown",  ( e ) => {

						if ( e.key === "Escape" && !modal.classList.contains( "hidden" ) ) {

							this.closeModal( modal, overlay );

						}

					} );

				}

			} );

		}

	}

}
